import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Globals {
    apiUrl = environment.apiUrl;
    hostUrl = environment.hostUrl;
}
